import { render, staticRenderFns } from "./RelatedInventoryRequestHistory.vue?vue&type=template&id=67a400e0&scoped=true&"
import script from "./RelatedInventoryRequestHistory.vue?vue&type=script&lang=js&"
export * from "./RelatedInventoryRequestHistory.vue?vue&type=script&lang=js&"
import style0 from "./RelatedInventoryRequestHistory.vue?vue&type=style&index=0&id=67a400e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a400e0",
  null
  
)

export default component.exports